var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwareness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 390,
    height: 302,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".s0{fill:#f7f7f7}.s1{fill:#ccc}.s3,.s4{fill:none}.s3{stroke:#000;stroke-linecap:round;stroke-width:2}.s4{stroke:#ccc;stroke-width:19.8}.s6{fill:#1f161e}.s8{fill:#207bbd}.s9{fill:#f8cdba}.s10{fill:#000}.s11{fill:#fa9e9f}.s12{fill:none;stroke:#1f161e;stroke-linecap:round;stroke-width:.7}.s13{fill:#69d2c9}.s14{fill:none;stroke:#1f161e;stroke-linecap:round;stroke-width:.6}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "M0 105.2h349v53H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "M12.6 115.7h51.7v32.6H12.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "M33.4 55h261.9c3 0 5.9.6 8.7 1.8 2.8 1.1 5.3 2.8 7.4 4.9 2.1 2.1 3.8 4.6 4.9 7.4 1.2 2.7 1.8 5.7 1.8 8.7v.4c0 3-.6 6-1.8 8.8-1.1 2.7-2.8 5.2-4.9 7.3-2.1 2.2-4.6 3.8-7.4 5-2.8 1.1-5.7 1.7-8.7 1.7H33.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "M50.5 0h281.6v21.7H50.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "M28.7 21.8h308.5v29H28.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.1 16.8c-3.3 0-6-2.7-6-5.9 0-3.3 2.7-6 6-6s6 2.7 6 6c0 3.2-2.7 5.9-6 5.9z",
    style: {
      fill: "#e2e2e2"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "M70.6 36.3h222.9M67.6 5v11.7M76.4 5v11.7M85.3 5v11.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "M33.4 26.1h7v20.3h-7zM43.5 26.1h7v20.3h-7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "M18.7 55h274.4c13.7 0 25 10.4 25 23s-11.3 23-25 23H18.7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m228.6 121.2-7.2-12.4-7.1 12.4V71.9h14.3z",
    style: {
      fill: "#707070"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "M80.5 132h238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M130 290.3q-.3.5-.4 1.1-.2.6-.2 1.2 0 .7.1 1.3.1.6.3 1.1c.5.7 5.2 3.5 5.6 4 .4.6-.4 1.7-1.2 2.1-.7.4-13.7-3.1-14.6-5.5-.6-1.3 1.7-7.1 2.1-8.2M47.3 281.6q-.3.6-.4 1.2-.2.5-.2 1.2-.1.6 0 1.2t.4 1.2c.5.7 5.2 3.4 5.6 4 .4.5-.4 1.6-1.2 2-.8.4-13.7-3.1-14.7-5.4-.5-1.3 1.8-7.2 2.2-8.2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.9 182.8c-1.4 2.3-19.9 32.7-42 50.9-3.8 6.9-29 48.3-31.6 49.2-2.5 1-14-2.9-14.5-4.9-.6-1.9 29.5-60.9 31.9-68.2 2.4-7.3 27.8-66.7 34.7-72.6 6.9-5.9 23 43.1 21.5 45.6z",
    style: {
      fill: "#145c90"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M144.1 156.2c3.6 5.5 19.7 53.7 18.4 63.5-1.3 9.7-29.8 71.2-32.3 71.9-2.4.6-8.8-1.6-9.9-4.2-1.1-2.7 12.6-73.9 12.6-73.9-2.6-2.9-29.8-50-28.1-72.8 1.7-22.8 39.3 15.5 39.3 15.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "M157.4 94.4c-.4 1.8-10.3-.6-9.8-2.6l3.1-11.9 9.9 2.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "M150.8 79.9c1-.4 1.4 2.7 3.5 4.2-1.8-1.2-5.2 1.9-5.4 2.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "M162.4 86.8c-7.4 0-13.3-5.9-13.3-13.2 0-7.3 5.9-13.3 13.3-13.3 7.3 0 13.2 6 13.2 13.3 0 7.3-5.9 13.2-13.2 13.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "M177 79.3c-.2.6-1.3.8-2.5.5-1.1-.3-2-1-1.8-1.7.2-.6 1.2-.8 2.4-.5 1.2.3 2 1 1.9 1.7zM163.5 75.7c-.1.6-1.2.9-2.4.6-1.2-.3-2-1.1-1.8-1.7.1-.6 1.2-.9 2.4-.5 1.2.3 2 1 1.8 1.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "M170.2 75c.3.7 1.7 3.6-.7 4M164.4 80.7q-.3-.2-.5-.4-.3-.2-.5-.5-.3-.3-.4-.6-.2-.3-.3-.6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "M149.1 74.2c-.1-3.2.9-6.3 2.8-8.8 2-2.5 4.8-4.2 7.9-4.8 3.1-.6 6.3-.1 9.1 1.5s4.9 4.1 5.9 7.1c-3.4-4.3-15.9-3-17.3-.4-1.3 2.5-6.5 4.9-8.4 5.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "M153.5 73.5c-1.6 0-2.9-1.3-2.9-3 0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9 0 1.7-1.3 3-2.9 3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "M100.3 140c1.3-3 43-129.3 44.5-130.5 1.5-1.2 9.4.7 9.5 2.4 0 2.5-14.8 67.6-14.5 68.8.3 1.2 22.9 16.6 22.9 16.6s21.8-21.7 22.6-23.1c.8-1.4 3.6-37 4.1-37.9.6-.8 8.8-2 9.2-1.6.5.5 2.1 39.2 1.6 41.4-.4 2.3-23.5 29.6-24.3 30.9-.7 1.3-28.3 50.6-30.5 51.8-2.3 1.1-29.2-5.1-45.1-18.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "M155.1 8c-.8 3.1-3.6 5-6.2 4.4-2.7-.7-4.3-3.7-3.5-6.8.8-3.1 3.5-5.1 6.2-4.4 2.7.6 4.2 3.7 3.5 6.8zM198.6 33.1c-.8 3.1-3.6 5-6.2 4.4-2.7-.7-4.3-3.7-3.5-6.8.8-3.1 3.5-5.1 6.2-4.4 2.7.6 4.2 3.7 3.5 6.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "M128.8 76.4q1.4.3 2.8.8 1.4.4 2.8 1 1.4.5 2.8 1.1l2.6 1.4M162.7 97.3q.6.3 1.2.7.5.3 1.1.7.5.3 1.1.7.5.4 1 .9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "M380.4 133c.4 1.2 4.5 6.8 6 9.3 1.5 2.5 4.1 9.8 1.9 11q-1.1.5-2.3.5-1.1 0-2.2-.5-1-.5-1.8-1.4-.7-1-1-2.1c-1.2-3.8-5.2-12.5-6.6-14.4-1.4-1.9 6-2.4 6-2.4zM224.6 19.9l.5.5-3.8 1.6-2.5-3h-.4q-.1.1-.3.1h-.7c-1.2 0-2.3-.3-3.2-1-1-.6-1.7-1.6-2.1-2.7-.4-1.1-.4-2.2-.1-3.4.3-1.1.9-2.1 1.8-2.8-3-3.2-5.5-6-5.9-6.6-1.1-1.5-.1-2.2 1.3-2.6.2 0 16.2 16.8 18.2 18.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M252.3 213.5c0 .8 1.5 7.7.8 8.6-1.2 1.5-11.7 1.4-12.2.9-.5-.4-.8-1.4-.4-1.7.4-.4 4.5-1.4 5.1-1.8q.2-.4.4-.9.3-.4.4-.9.1-.5.1-.9 0-.5-.1-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325 114.5c4.6 3.2 50.5 139 49.8 141.2-.8 2.1-6 3.3-7.9 2.1-1.9-1.2-37.6-65.8-39.5-67.7-1.9-1.9-29.9-31.1-33.7-42.6-3.9-11.5 31.3-33 31.3-33z",
    style: {
      fill: "#65b7b0"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "M318.6 106.7c2.9 1.6 11.4 9.9 11.4 18.7 0 25.1-23 30.1-31.2 30-8.2-.2-42 1.2-54.9-3.1.6 4.9 4.9 48.6 8.9 61.4-1 1.8-6 3.4-6.9 2.6-7.3-5.9-28.8-68.3-28.3-72.7.9-9.9 95.7-35.6 101-36.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m293.5 51.2 9.9 2.3-2.8 12c-.4 2-10.3-.5-9.9-2.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "M301.8 60.7c.2-1.1-1.4-5.4-3.4-5.2 2.5-.3 4.3-2.8 5-2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "M296.1 55.7c-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.3 13.2-13.3 7.3 0 13.2 6 13.2 13.3 0 7.3-5.9 13.2-13.2 13.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "M284.8 41.7c-.1.6-1.2.9-2.4.6-1.2-.3-2-1-1.9-1.6.2-.6 1.2-.9 2.4-.6 1.2.2 2.1 1 1.9 1.6zM298.3 44.8c-.1.6-1.2.9-2.4.6-1.2-.2-2-1-1.9-1.6.2-.6 1.3-.9 2.4-.6 1.2.3 2.1 1 1.9 1.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "M288.5 40.1c-.6.5-3.2 2.4-1.2 3.9M293.5 46.8l-.6.4q-.3.2-.6.3-.3.1-.7.2-.3.1-.7.1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "M302.6 40.5c0-3-10.5-9.9-15.5-7.7 2.3-2.2 5.4-3.4 8.5-3.5 3.2-.1 6.3.9 8.8 2.9 2.4 2 4.1 4.8 4.7 7.9.5 3.1 0 6.3-1.6 9.1-1.4-1.3-4.9-5.9-4.9-8.7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "M305.3 46.8c-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9 0 1.6-1.3 2.9-2.9 2.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M226.3 17.7c1.4 1.3 29.3 28.8 34 30 15.8 3.8 67.2 19.2 84.7 33.2 18.2 11.3 37.6 50.9 36.9 52.3-.7 1.4-8.4 4.8-10 4.1-1.6-.7-23.2-30.7-26.6-32.6-3.3-1.9-29.4-14.8-29.4-14.8 1.2 3 4.8 15.7 4.2 17.4-.5 1.8-11.9 9.4-32.5 11.3-2.2-1.2-8.3-37-8.3-37-4.4-1.9-33.6-17.4-40-25.5-2.5-3.1-21.3-32-21.3-33.5 0-1.4 8.3-4.9 8.3-4.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "M293 88.5c-1.8-.7-13.6-6.9-13.6-6.9M303.8 61.6c1.2 1.5 10.1 19.8 12.1 28.5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M373.8 255.5q.4.5.8 1.1.4.5.7 1.1l.6 1.2q.2.6.4 1.3c.5 5.2-5.1 13.3-6.1 13.3-2.6 0-3.9-1.4-3.9-3.1 0-1.6 1.9-3.6 1.9-4.7s-.2-7.6-.4-8.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwareness);
export default __webpack_public_path__ + "static/media/awareness.7628eddb993f09e9ef1d90955669b8d1.svg";
export { ForwardRef as ReactComponent };